var _defs, _sodipodiNamedview, _metadata;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketmaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 540.69482,
    height: 76.68399,
    id: "svg2",
    viewBox: "0 0 540.69482 76.68399",
    inkscapeversion: "0.48.4 r9939",
    sodipodidocname: "TicketMaster old logo.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17.3945,77.1797 0,0 l 2288.45,0 16.06,77.1797 -2287.1155,0 z",
    id: "path44",
    "inkscapeconnector-curvature": 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TicketMaster") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageopacity: 0,
    inkscapepageshadow: 2,
    inkscapezoom: 1.4,
    inkscapecx: 262.27007,
    inkscapecy: 39.527673,
    "inkscapedocument-units": "px",
    "inkscapecurrent-layer": "layer1",
    showgrid: "false",
    "inkscapewindow-width": 1366,
    "inkscapewindow-height": 706,
    "inkscapewindow-x": -8,
    "inkscapewindow-y": -8,
    "inkscapewindow-maximized": 1,
    "fit-margin-top": 0,
    "fit-margin-left": 0,
    "fit-margin-right": 0,
    "fit-margin-bottom": 0
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfresource: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfresource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    inkscapelabel: "Layer 1",
    inkscapegroupmode: "layer",
    id: "layer1",
    transform: "translate(-161.29331,-985.67882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(2.2381056,0,0,-2.2381056,155.79858,1086.2886)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "scale(0.1,0.1)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1536.16,150.945 c 44.99,0 58.9,30.996 68.32,68.332 l -21.11,0 c -29.21,0 -77.73,-4.972 -77.73,-44.043 0,-16.191 15.24,-24.289 30.52,-24.289 m 58.9,-3.14 -0.91,0 c -20.66,-26.067 -41.33,-40.903 -74.61,-40.903 -41.77,0 -71.43,23.379 -71.43,66.047 0,76.403 85.38,82.258 142,82.258 l 21.11,0 c 1.82,6.309 1.82,13.047 1.82,19.758 0,23.379 -25.17,30.117 -46.31,30.117 -26.5,0 -52.12,-6.738 -75.93,-17.973 l 8.55,48.09 c 25.59,8.977 51.67,13.926 78.64,13.926 46.26,0 89.87,-17.09 89.87,-71.445 0,-31.02 -22.92,-121.782 -28.33,-165.395 l -50.76,0 6.29,35.52",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.9883,343.941 43.5859,0 10.332,47.618 64.7228,21.14 -14.832,-68.758 53.914,0 -9.43,-44.043 -53.926,0 -22.023,-101.121 c -1.344,-5.398 -2.687,-13.472 -2.687,-22.449 0,-13.926 9.437,-22.473 22.902,-22.473 10.808,0 21.582,2.239 29.215,5.383 L 145.441,112.5 c -10.339,-2.234 -22.011,-5.402 -32.359,-5.402 -40.8906,0 -69.664,16.195 -69.664,60.707 0,17.957 3.5976,35.476 7.6328,53.883 l 17.0859,78.21 -43.5859,0 9.4375,44.043",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 238.469,443.723 60.222,0 -12.582,-57.547 -60.226,0 12.586,57.547 z m -22.024,-99.782 60.227,0 -49.442,-231.441 -60.234,0 49.449,231.441",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 458.508,290.918 c -11.676,7.641 -27.403,11.672 -44.043,11.672 -48.074,0 -75.035,-44.93 -75.035,-88.528 0,-30.089 9.871,-60.207 51.226,-60.207 14.84,0 33.27,4.043 48.985,11.692 l -6.75,-47.664 c -18.426,-8.977 -38.2,-10.785 -57.973,-10.785 -59.762,0 -98.398,40 -98.398,99.777 0,80.879 53.468,142.445 136.593,142.445 22.489,0 44.051,-4.047 60.227,-8.972 l -14.832,-49.43",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 524.555,449.531 60.222,0 -40.011,-189.633 0.929,0 84.032,84.043 78.183,0 -110.98,-105.609 69.629,-125.832 -67.852,0 -59.785,122.684 -0.879,0 -26.07,-122.684 -58.868,0 71.45,337.031",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 924.98,343.941 43.586,0 10.332,47.618 64.722,21.14 -14.83,-68.758 53.93,0 -9.45,-44.043 -53.92,0 -22.026,-101.121 c -1.347,-5.398 -2.679,-13.472 -2.679,-22.449 0,-13.926 9.425,-22.473 22.915,-22.473 10.78,0 21.56,2.239 29.19,5.383 L 1036.44,112.5 c -10.35,-2.234 -22.03,-5.402 -32.37,-5.402 -40.89,0 -69.66,16.195 -69.66,60.707 0,17.957 3.594,35.476 7.652,53.883 l 17.059,78.21 -43.578,0 9.437,44.043",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 904.836,261.254 c 0,58.851 -37.742,88.066 -94.813,88.066 -75.945,0 -131.687,-69.207 -131.687,-141.09 0,-68.757 44.945,-101.132 111.473,-101.132 24.703,0 50.324,5.851 73.691,13.047 l 7.633,47.66 c -22.465,-10.375 -46.297,-16.664 -71.012,-16.664 -38.508,0 -61.016,13.695 -63.898,50.07 l -0.047,0 c -0.106,2.109 -0.313,4.18 -0.313,6.394 0,0.43 0.02,0.864 0.02,1.29 0,0.246 -0.02,0.429 -0.02,0.675 l 0.043,0 c 0.27,15.84 3.746,31.469 9.797,45.914 11.574,29.446 27.918,49.793 63.418,49.793 25.149,0 38.199,-13.906 38.199,-38.64 0,-5.383 -0.461,-10.332 -1.343,-15.715 l -82.407,0 c -5.347,-18.192 -6.273,-30.375 -6.382,-41.352 l 141.796,0 c 3.598,17.09 5.852,34.16 5.852,51.684",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1108.7,318.32 c 1.78,8.981 3.59,18.407 4.93,25.621 l 56.19,0 -5.4,-31.003 0.9,0 c 16.18,23.789 42.68,36.382 70.99,36.382 27.42,0 55.73,-16.168 58.88,-44.043 l 0.9,0 c 15.29,30.118 49,44.043 81.33,44.043 34.59,0 64.28,-28.304 64.28,-63.351 0,-20.664 -5.43,-44.043 -10.35,-62.903 l -24.27,-110.566 -60.23,0 24.28,112.805 c 3.15,13.929 7.64,35.519 7.64,49.425 0,17.09 -13.02,27.86 -28.3,27.86 -41.81,0 -52.14,-48.547 -59.79,-79.996 l -23.8,-110.094 -60.22,0 24.27,112.805 c 3.16,13.929 7.64,35.519 7.64,49.425 0,17.09 -13.05,27.86 -28.33,27.86 -40.88,0 -52.12,-48.977 -59.75,-79.996 l -23.83,-110.094 -60.2,0 42.24,205.82",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1846.71,296.816 c -6.46,3.532 -23.08,8.461 -40.15,8.461 -17.99,0 -40.45,-4.929 -40.45,-23.336 0,-29.23 78.19,-40.015 78.19,-96.636 0,-60.239 -52.57,-78.207 -104.23,-78.207 -24.29,0 -48.57,3.593 -70.57,13.949 l 13.05,48.074 c 17.04,-9.414 34.14,-17.98 57.52,-17.98 20.18,0 41.33,6.757 41.33,25.617 0,37.304 -78.2,40.926 -78.2,98.879 0,54.351 52.58,73.683 100.2,73.683 22.04,0 44.52,-4.047 56.36,-7.125 l -13.05,-45.379",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1885.21,343.941 43.59,0 10.33,47.618 64.69,21.14 -14.82,-68.758 53.93,0 -9.42,-44.043 -53.96,0 -22.02,-101.121 c -1.33,-5.398 -2.69,-13.472 -2.69,-22.449 0,-13.926 9.46,-22.473 22.93,-22.473 10.78,0 21.57,2.239 29.21,5.383 L 1996.63,112.5 c -10.34,-2.234 -22,-5.402 -32.33,-5.402 -40.91,0 -69.67,16.195 -69.67,60.707 0,17.957 3.62,35.476 7.65,53.883 l 17.07,78.21 -43.6,0 9.46,44.043",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2293.47,312.938 c 1.78,9.867 3.59,20.214 5.4,31.003 l 57.52,0 -8.1,-43.593 0.91,0 c 10.81,25.164 40.43,48.972 68.3,48.972 7.65,0 15.72,-0.429 22.91,-2.234 l -12.57,-58.859 c -6.73,2.242 -15.31,3.593 -22.93,3.593 -42.71,0 -63.37,-38.207 -70.99,-75.511 l -21.58,-103.809 -60.21,0 41.34,200.438",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2251.68,261.254 c 0,58.851 -37.75,88.066 -94.82,88.066 -75.93,0 -131.68,-69.207 -131.68,-141.09 0,-68.757 44.94,-101.132 111.46,-101.132 24.69,0 50.33,5.851 73.71,13.047 l 7.62,47.66 c -22.47,-10.375 -46.28,-16.664 -71,-16.664 -38.53,0 -61.02,13.695 -63.93,50.07 l -0.04,0 c -0.09,2.109 -0.3,4.18 -0.3,6.394 0,0.43 0.03,0.864 0.03,1.29 0,0.246 -0.03,0.429 -0.03,0.675 l 0.03,0 c 0.27,15.84 3.75,31.469 9.8,45.914 11.56,29.446 27.92,49.793 63.42,49.793 25.16,0 38.21,-13.906 38.21,-38.64 0,-5.383 -0.47,-10.332 -1.34,-15.715 l -82.4,0 c -5.38,-18.192 -6.29,-30.375 -6.42,-41.352 l 141.83,0 c 3.6,17.09 5.85,34.16 5.85,51.684",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36",
    "inkscapeconnector-curvature": 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g40",
    clipPath: "url(#clipPath42)",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "matrix(2306.4,0,0,79.2,0.00499344,-2.01292)",
    style: {
      fill: "#000000"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketmaster);
export default __webpack_public_path__ + "static/media/ticketmaster.b334a1643552fd7a5c244db6af347149.svg";
export { ForwardRef as ReactComponent };